import { COUNTRY_CODES, UNIDENTIFIED_COUNTRY } from './constants';

export const getValidatedCountry = (country?: string | null): string => {
  if (!country) {
    return UNIDENTIFIED_COUNTRY;
  }
  const isValid = COUNTRY_CODES.includes(country);
  return isValid ? country : UNIDENTIFIED_COUNTRY;
};
